import React from 'react';
import { Trash2 } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, booking, onConfirm, onCancel }) => {
  if (!isOpen || !booking) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-red-100 rounded-full">
            <Trash2 className="h-5 w-5 text-red-600" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Delete OT Booking</h3>
        </div>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete the OT booking for <strong>{booking.patient_name}</strong> (UHID: {booking.uhid_no})? 
          This action cannot be undone.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Delete Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
